import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomepageComponent } from "./components/homepage/homepage.component";
import { DemouserComponent } from "./components/layout/demouser/demouser.component";
import { StepperContainerComponent } from "./components/stepper-container/stepper-container.component";
import { AuthGuard } from "./guard/auth.guard";
import { CounselorSignupComponent } from "./components/layout/counselor-signup/counselor-signup.component";
import { PaymentComponent } from "./components/layout/payment/payment.component";
import { ForgotPasswordComponent } from "./components/layout/forgot-password/forgot-password.component";
import { MyAccountsComponent } from "./components/my-accounts/my-accounts.component";

const routes: Routes = [
  // {
  //   path: "",
  //   redirectTo: "top5/home/login",
  //   pathMatch: "full",
  // },

  // {
  //   path: "top5",
  //   redirectTo: "top5/home/dashboard",
  //   pathMatch: "full",
  {
    path: "home",

    children: [
      {
        path: "student",
        component: DemouserComponent,
        // canActivate: [AuthGuard],
      },
      {
        path: "payment-success",
        component: PaymentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "ResetPassword",
        component: ForgotPasswordComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "signUp",
        component: CounselorSignupComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: "counselor",
            component: CounselorSignupComponent,
            canActivate: [AuthGuard],
          },
          {
            path: "counselor?org='top5'",
            component: CounselorSignupComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: "student?couponCode='WALLIN'",
        component: DemouserComponent,
        canActivate: [AuthGuard],
      },

      {
        path: "login",
        component: HomepageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "demouser",
        component: DemouserComponent,
      },
      {
        path: "Student?org='top5'",
        component: DemouserComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "dashboard/:page/:formfilledid",
        component: HomepageComponent,
      },
      {
        path: "login/:page/:formfilledid",
        component: HomepageComponent,
        // canActivate: [AuthGuard],
      },
      {
        path: "steps/:page",
        component: StepperContainerComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "steps/:page/:formfilledid",
        component: StepperContainerComponent,
      },
      {
        path: "Accounts",
        component: MyAccountsComponent,
      },
    ],
  },
  {
    path: "",
    redirectTo: "home/step/0",
    pathMatch: "full",
  },
];

@NgModule({
  // imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy' })],
  // exports: [RouterModule]
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
